import './styles.scss'
import * as React from 'react'
import { CustomInput } from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import _ from 'lodash'

import { Button, SelectWithLabel } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { checkScheduleRanges, getRangeSelectorClassNames, nextRangeStart, allowAddRange } from './utils'

const TIME_END_OF_DAY = moment().endOf('day').toDate()

const DaysRange = (props) => {
  const { schedules } = props
  const [rangeError, setRangeError] = React.useState({})

  React.useEffect(() => {
    setRangeError(checkScheduleRanges(schedules))
  }, [])

  React.useEffect(() => {
    props.onChangeError(rangeError)
  }, [rangeError])

  const handleStatusChange = (day) => {
    let newSchedule = schedules
    newSchedule[day].isActive = !newSchedule[day].isActive
    props.updateSchedule({ scheduleName: props.scheduleName, schedule: newSchedule, isActiveChange: true })
  }

  const handleChangeDate = (params = {}) => {
    const { rangeType, day, date, rangePosition = 0 } = params
    let newSchedule = schedules
    const hours = (date.getHours() < 10 ? '0' : '') + date.getHours()
    const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    newSchedule[day].ranges[rangePosition][rangeType] = `${hours}:${minutes}`
    props.updateSchedule({ scheduleName: props.scheduleName, schedule: newSchedule })
    setRangeError(checkScheduleRanges(newSchedule))
  }

  const addRange = (day) => {
    const currentRanges = schedules[day]?.ranges || []

    const isAllow = allowAddRange(currentRanges)
    if (!isAllow) return false

    const endRange = currentRanges?.[currentRanges.length - 1]
    const newSchedule = schedules
    const nextStart = nextRangeStart(endRange?.end)

    newSchedule[day].ranges.push({
      start: nextStart,
      end: '23:59',
    })

    props.updateSchedule({ scheduleName: props.scheduleName, schedule: newSchedule })

    return true
  }

  const handleCopyAll = () => {
    const mondaySchedule = schedules?.monday
    if (!mondaySchedule) return

    const schedule = {
      ...schedules,
      tuesday: _.cloneDeep(mondaySchedule),
      wednesday: _.cloneDeep(mondaySchedule),
      thursday: _.cloneDeep(mondaySchedule),
      friday: _.cloneDeep(mondaySchedule),
      saturday: _.cloneDeep(mondaySchedule),
      sunday: _.cloneDeep(mondaySchedule)
    }
    props.updateSchedule({ scheduleName: props.scheduleName, schedule })
  }

  const removeRange = (day, index) => {
    if (schedules[day].ranges[index]) {
      let newSchedule = schedules
      newSchedule[day].ranges.splice(index, 1)
      props.updateSchedule({ scheduleName: props.scheduleName, schedule:newSchedule })
    }
  }

  return (
    <div className='days-range'>
      {props.daysSelectorInset && (
        <div className='days-selector-container'>
          <SelectWithLabel
            label={lang('dashboard_weekdays')}
            options={props.options}
            value={props.selectedOption}
            onChange={d => props.changeDaysSelector({ scheduleName: props.scheduleName, d })}
          />
        </div>
      )}
      {Object.keys(schedules).map((prop, index) => {
        return (
          <div className='days-range-option' key={`${prop}-${index}`}>
            <div className='switch-container'>
              <CustomInput
                id={`nightTime.${prop}-${props.scheduleName}`}
                type='switch'
                name={`nightTime.${prop}`}
                checked={schedules[prop].isActive}
                onChange={() => handleStatusChange(prop)}
                label={lang(`dashboard_${prop}`)}
              />
            </div>
            <div className='selector-ranges-container'>
              {
                schedules[prop] && schedules[prop].ranges
                  ? schedules[prop].ranges.map((range, index) => {
                    const startDate = new Date(0, 0, 0, Number(range.start.slice(0, 2)), Number(range.start.slice(3, 5)))
                    const beforeRangeEndDate =
                  index > 0
                    ? new Date(0, 0, 0, Number(schedules[prop].ranges[index - 1].end.slice(0, 2)), Number(range.start.slice(3, 5)))
                    : null
                    return (
                      <div className={index > 0 ? 'selector-container-margin' : 'selector-container'} key={`${range}-${index}`}>
                        <div className='selector-start-container'>
                          <DatePicker
                            className={getRangeSelectorClassNames({ day: prop, rangePosition: index, rangeType: 'start', rangeError })}
                            selected={startDate}
                            onChange={date => handleChangeDate({ rangeType: 'start', day: prop, date, rangePosition: index })}
                            showTimeSelect
                            showTimeSelectOnly
                            // timeIntervals={30}
                            timeCaption='Time'
                            dateFormat='HH:mm'
                            timeFormat='HH:mm'
                            injectTimes={[
                              TIME_END_OF_DAY
                            ]}
                            minTime={beforeRangeEndDate ? moment(beforeRangeEndDate).add('30', 'm').toDate() : null}
                            maxTime={beforeRangeEndDate ? moment().endOf('day').toDate() : null}
                          />
                        </div>
                        <span className='middle-text'>a</span>
                        <div className='selector-end-container'>
                          <DatePicker
                            className={getRangeSelectorClassNames({ day: prop, rangePosition: index, rangeType: 'end', rangeError })}
                            selected={new Date(0, 0, 0, Number(range.end.slice(0, 2)), Number(range.end.slice(3, 5)))}
                            onChange={date => handleChangeDate({ rangeType: 'end', day: prop, date, rangePosition: index })}
                            showTimeSelect
                            showTimeSelectOnly
                            // timeIntervals={30}
                            timeCaption='Time'
                            dateFormat='HH:mm'
                            timeFormat='HH:mm'
                            injectTimes={[
                              TIME_END_OF_DAY
                            ]}
                            minTime={moment(startDate).add('30', 'm').toDate()}
                            maxTime={moment().endOf('day').toDate()}
                          />
                        </div>
                        <div className='delete-range-button-container'>
                          <i className='fa fa-times fa-sm close-button' onClick={() => removeRange(prop, index)} />
                        </div>
                      </div>
                    )
                  })
                  : null
              }
            </div>
            <div className='add-range-button-container'>
              {
                allowAddRange(schedules[prop].ranges) ? (
                  <i className='fa fa-plus-circle fa-lg plus-button' onClick={() => addRange(prop)} />
                ) : null
              }
            </div>
            {prop === 'monday' ? (
              <div className='days-range__copy-all-btn-container'>
                <Button
                  clearPrimary
                  icon={
                    <figure>
                      <img src={getStaticImage('/icons/orange-brand/icon-copy-primary.svg')} alt='Copy all' />
                    </figure>
                  }
                  value={lang('dashboard_copy-to-all')}
                  onClick={handleCopyAll}
                />
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}

export default DaysRange
